module.exports = __webpack_public_path__ + "img/cresc_top2.c6ed338e.jpg";